import { useDebouncedLoading } from '../../hooks/useDebouncedLoading';
import { LoadingSpinner } from './LoadingSpinner';

interface LoadingOverlayProps {
  isLoading: boolean;
  children: React.ReactNode;
  loadingText?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  /** Override default debounce options */
  debouncedOptions?: {
    showDelay?: number;
    minDisplayTime?: number;
    cooldownPeriod?: number;
  };
}

/**
 * Modern loading overlay with debounced loading states to prevent flickering
 */
export function LoadingOverlay({ 
  isLoading, 
  children, 
  loadingText, 
  className = '',
  size = 'md',
  debouncedOptions
}: LoadingOverlayProps) {
  const { isVisible } = useDebouncedLoading(isLoading, debouncedOptions);

  return (
    <div className={`relative ${className}`}>
      {children}
      {isVisible && (
        <div className="absolute inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-10">
          <div className="flex flex-col items-center space-y-2">
            <LoadingSpinner size={size} />
            {loadingText && (
              <p className="text-sm text-gray-600 animate-pulse">{loadingText}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}